<div
  class="relative z-10 top-0 left-0 bg-grayscaleWhite w-full h-[54px] shadow-sm px-8 py-4"
  @fadeAnimation
>
  <img
    class="block h-[20px] w-auto ml-0"
    height="60"
    width="80"
    src="assets/img/libertador.svg"
    alt="Libertador logo"
  />
</div>
